import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Typography, Link } from '@mui/material';

import { TitleHead } from './TitleHead';

type NavigatorProps = {
  current: string;
  parents: { title: string; link: string }[];
};

export const Navigator = (props: NavigatorProps) => {
  const { current, parents } = props;

  return (
    <Box mt={3}>
      <TitleHead title={current} />
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {parents.map((p) => (
          <Typography variant="h6" key={p.title}>
            <Link underline="hover" color="secondary" href={p.link}>
              {p.title}
            </Link>
          </Typography>
        ))}
        <Typography variant="h6">{current}</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default Navigator;
